//window.$ = window.jQuery = require('jquery');

import $ from "jquery";
window.$ = window.jQuery = $;
import "@/assets/js/jquery.meanmenu.min.js";

//require('../public/js/all.js');

//import "../public/css/bootstrap.min.css"
//import "../public/css/style.css"
//import "../public/css/style-responsive.css"

import i18n from './i18n';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App);

//require('../public/js/all.js');


async function detectCountryAndSetLanguage() {
  	try {
    	const response = await fetch('https://geolocation-db.com/json/');
    	const data = await response.json();
    	const country = data.country_code;
	    if (['ME', 'MK', 'SR'].includes(country)) {
	      	i18n.global.locale.value = 'sr';
	    } else if (['AL', 'XK', 'KS'].includes(country)) {
	      	i18n.global.locale.value = 'sq';
	    } else {
	      	i18n.global.locale.value = 'en';
	    }
  	} catch (error) {
      	i18n.global.locale = 'en';
    	console.error('Error detecting location:', error);
  	}
}



detectCountryAndSetLanguage().then(() => {
	app.use(i18n);
  	app.use(router);
  	app.mount('#app');
});


//createApp(App).use(router).mount('#app')